import axios from 'axios';
import consts from './consts';

import { showErrorMessages } from '../state/app/appActions';
import { types } from '../state/auth/authActions';

export const setupAxiosInterceptors = (store) => {
  axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response && [401, 403].includes(error.response.status)) {
          console.log('requestAgent');
          handleErrors(error.response, store.dispatch);
          store.dispatch({ type: types.AUTH_LOGOUT });
          // document.location.href = "/";
          return null;
        }
        return Promise.reject(error);
      }
  );
};

export const rest = async (method, resorce, data = {}, dispatch) => {
  return axios[method](`${consts.API_URL}${resorce}`, {
    ...data
  }).then(response => {
    handleErrors(response, dispatch);
    return response ? response.data : null;
  }).catch((error) => {
    handleErrors(error.response, dispatch);
    return null;
  });
};

const handleErrors = (response, dispatch) => {
  if (!dispatch) { return; }
  let errorMessage = '';
  if (response && response.data && response.data.errors) {
    errorMessage = response.data.errors[0].message;
    
    if (errorMessage.includes('Unauthorized') || errorMessage.includes('Not Authorised') || errorMessage.includes('jwt expired')) {
      dispatch(showErrorMessages([{ message: 'Acesso expirado!' }]));
      dispatch({ type: types.AUTH_LOGOUT });
      document.location.href = "/";
    } else {
      dispatch(showErrorMessages(response.data.errors));
    }
  } else if (response.status === 503) {
    dispatch(showErrorMessages([{ message: 'Serviço indisponível' }]));
  } else if (response.status === 504) {
    dispatch(showErrorMessages([{ message: 'O serviço demorou a responder' }]));
  }
};
